import { useState } from 'react';
import { Button, FormGroup, Input, Label, Row, Col } from 'reactstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useDataFetch } from '../../Hooks/Use-data-fetch';

// Píldoras rápidas de Estado (README pantalla 2). No cubren los 8 estados
// del backend, sólo los más frecuentes; el select "Estado" de abajo sigue
// dando acceso al resto (Creada, Pendiente de comprobante, Pagada…).
const QUICK_PILLS = [
  { label: 'Todas', value: '' },
  { label: 'Pendientes', value: 'PENDING_APPROVAL' },
  { label: 'En proceso', value: 'PROCESSING' },
  { label: 'Enviadas', value: 'SHIPPED' },
  { label: 'Canceladas', value: 'CANCELLED' },
];

export const FormFilterOrder = ({
  statusFilter,
  setStatusFilter,
  countryFilter,
  setCountryFilter,
  userFilter,
  setUserFilter,
  dateRange,
  setDateRange,
  handleSearch,
  paymentMethodFilter,
  setPaymentMethodFilter,
  wompiReference,
  setWompiReference,
  orderIdFilter,
  setOrderIdFilter,
  totalOrders = 0,
}) => {
  const { getData } = useDataFetch();
  const [showMore, setShowMore] = useState(false);

  const { data: countriesData } = getData(
    ['countries-available'],
    '/product/countries-available/all'
  );

  const [startDate, endDate] = dateRange;

  const selectPill = (value) => {
    setStatusFilter(value);
    handleSearch({ status: value });
  };

  return (
    <>
      <div className="d-flex align-items-center gap-2 flex-wrap w-100">
        {QUICK_PILLS.map((pill) => (
          <span
            key={pill.value}
            className={`ui-pill${statusFilter === pill.value ? ' ui-pill--active' : ''}`}
            onClick={() => selectPill(pill.value)}
          >
            {pill.label}
            {pill.value === '' && <span className="ui-pill__count">{totalOrders.toLocaleString()}</span>}
          </span>
        ))}

        <div style={{ width: 1, height: 26, background: '#E8EAF2', margin: '0 4px' }} />

        <FormGroup className="mb-0">
          <Input
            type="select"
            bsSize="sm"
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            style={{ width: 'auto' }}
          >
            <option value="">Estado: todos</option>
            <option value="CREATED">Creada</option>
            <option value="PENDING_PROOF">Pendiente de comprobante</option>
            <option value="PENDING_APPROVAL">Pendiente por aprobar</option>
            <option value="PAID">Pagada</option>
            <option value="PROCESSING">En proceso</option>
            <option value="SHIPPED">Enviada</option>
            <option value="DELIVERED">Entregada</option>
            <option value="CANCELLED">Cancelada</option>
          </Input>
        </FormGroup>

        <FormGroup className="mb-0">
          <Input
            type="select"
            bsSize="sm"
            value={countryFilter}
            onChange={(e) => setCountryFilter(e.target.value)}
            style={{ width: 'auto' }}
          >
            <option value="">País: todos</option>
            {countriesData?.data?.countries?.map((country) => (
              <option key={country.id} value={country.name}>{country.name}</option>
            ))}
          </Input>
        </FormGroup>

        <FormGroup className="mb-0">
          <Input
            type="select"
            bsSize="sm"
            value={paymentMethodFilter}
            onChange={(e) => setPaymentMethodFilter(e.target.value)}
            style={{ width: 'auto' }}
          >
            <option value="">Método de pago: todos</option>
            <option value="CASH">Efectivo</option>
            <option value="TRANSFER">Transferencia</option>
            <option value="LINK">Link de pago</option>
            <option value="PROVIDER">Proveedor</option>
          </Input>
        </FormGroup>

        <DatePicker
          className="form-control form-control-sm"
          wrapperClassName="ui-date-wrapper"
          selectsRange
          startDate={startDate}
          endDate={endDate}
          onChange={(update) => setDateRange(update)}
          showMonthDropdown
          showYearDropdown
          dateFormat="dd/MM/yyyy"
          placeholderText="Rango de fechas"
          isClearable
        />

        <Button color="primary" size="sm" onClick={() => handleSearch()}>
          <i className="ri-search-line me-1" /> Buscar
        </Button>

        <Button color="link" size="sm" className="ms-auto text-decoration-none" onClick={() => setShowMore((v) => !v)}>
          {showMore ? 'Ocultar más filtros' : 'Más filtros'}
        </Button>
      </div>

      {showMore && (
        <Row className="gx-3 gy-2 align-items-end w-100 mt-1">
          <Col xs="12" sm="4" md="3">
            <FormGroup className="mb-0">
              <Label className="form-label mb-1">ID Orden</Label>
              <Input
                type="text"
                bsSize="sm"
                placeholder="ID de la orden"
                value={orderIdFilter}
                onChange={(e) => setOrderIdFilter(e.target.value)}
              />
            </FormGroup>
          </Col>

          <Col xs="12" sm="4" md="3">
            <FormGroup className="mb-0">
              <Label className="form-label mb-1">Usuario</Label>
              <Input
                type="text"
                bsSize="sm"
                placeholder="Nombre"
                value={userFilter}
                onChange={(e) => setUserFilter(e.target.value)}
              />
            </FormGroup>
          </Col>

          <Col xs="12" sm="4" md="3">
            <FormGroup className="mb-0">
              <Label className="form-label mb-1">Referencia Wompi</Label>
              <Input
                type="text"
                bsSize="sm"
                placeholder="Referencia Wompi"
                value={wompiReference}
                onChange={(e) => setWompiReference(e.target.value)}
              />
            </FormGroup>
          </Col>
        </Row>
      )}
    </>
  );
};
